import { useStore } from "effector-react"
import React, { useEffect } from "react"
import { $demandFiles, queryDemFiles } from "../logics/demandFiles"
import { DemandFile } from "../atoms/DemandFile"


interface IDemandFiles {
  demid: number
}

export const DemandFiles = ({demid}: IDemandFiles) => {
  const {loaded, fail, failMsg, files} = useStore($demandFiles)
  useEffect(() => {
    queryDemFiles({demandId: demid})
  }, [])
  if(!loaded) {
    return <div className="row col-12 m-auto">Загрузка файлов...</div>
  }
  if(fail || !files || (files && files.length === 0)) return <></> //<div className="row col-12 m-auto">{failMsg}</div>
  return (
    <>
      <div style={{fontFamily: 'SF Pro Display', fontWeight: 700, fontSize: '20px', marginBottom: '16px'}}>Прикреплённые файлы({files.length})</div>
      <ul className="list-group">
        {files.map((f, i) => (
          <DemandFile key={i} file={f} urlPrefix="https://izba.kras-abs.ru/"/>
        ))}
      </ul>
    </>
  )
}
